import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  getAutomatedEmailCampaignConfigurationSettings,
  IAutomatedCampaignConfig,
  saveAutomatedEmailCampaignConfigurationSettings,
} from 'wisestep-api';

import { failed, success } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import {
  campaignConfigSchema,
  defaulCampaignConfigValues,
  campaignConfigType,
} from '../../schemas/campaignSettingsSchema';
import { buildCampaignConfigDefaultValues, CampaignSettingTypes } from '../../utils';

import AdditionalRulesCard from './AdditionalRulesCard';
import CandidateRulesCard from './CandidateRulesCard';
import SendEmailRuleCard from './SendEmailRuleCard';

const CampaignSettings = () => {
  const [defaultFormValues, setDefaultFormValues] = useState<campaignConfigType>(
    defaulCampaignConfigValues
  );
  const methods = useForm<campaignConfigType>({
    resolver: yupResolver(campaignConfigSchema),
    defaultValues: defaultFormValues,
    mode: 'onChange',
  });
  const { handleSubmit, reset } = methods;
  const setNotification = useNotificationStore((state) => state.setNotification);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getAutomatedEmailCampaignConfigurationSettings();
        const defaultValues = buildCampaignConfigDefaultValues(res?.data);
        setDefaultFormValues(defaultValues);
        reset(defaultValues);
      } catch (e) {
        console.error('Something went wrong', e);
        setNotification(failed('Failed to load campaign Configuration Data'));
      }
    };
    fetchData();
  }, [reset, setNotification]);

  const handleFormSubmit = async (data, cardType: CampaignSettingTypes) => {
    console.log(cardType);
    try {
      const res = await saveAutomatedEmailCampaignConfigurationSettings({
        ...data,
        fromEmail: data?.senderEmail?.fromEmail,
        preferredAccountId: data?.senderEmail?.id,
        fromName: data?.senderEmail?.fromName,
        signature: data?.senderEmail?.signatureText,
        threshold: data?.threshold?.[0],
      } as IAutomatedCampaignConfig);
      const defaultValues = buildCampaignConfigDefaultValues(res?.data);
      setDefaultFormValues(defaultValues);
      setNotification(success('Email Campaign Configuration Saved Successfully'));
    } catch (e) {
      console.error('Something went wrong', e);
      setNotification(failed('Failed to save campaign configuration data'));
    }
  };

  const onReset = () => reset(defaultFormValues);
  return (
    <FormProvider {...methods}>
      <form>
        <Grid display="flex" direction="column" rowGap={2}>
          <CandidateRulesCard
            onReset={onReset}
            onSave={() =>
              handleSubmit((data) => handleFormSubmit(data, CampaignSettingTypes.CANDIDATE_RULES))()
            }
          />
          <AdditionalRulesCard
            onReset={onReset}
            onSave={() =>
              handleSubmit((data) =>
                handleFormSubmit(data, CampaignSettingTypes.ADDITIONALE_RULES)
              )()
            }
          />
          <SendEmailRuleCard
            onReset={onReset}
            onSave={() =>
              handleSubmit((data) =>
                handleFormSubmit(data, CampaignSettingTypes.SENDER_EMAIL_RULES)
              )()
            }
          />
        </Grid>
      </form>
    </FormProvider>
  );
};

export default CampaignSettings;
